import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SalesEntityService } from 'app/layout/sales-entity/sales-entity-service/sales-entity-service';
import { BindingContext } from 'app/shared/models/BindingContext';
import { SalesEntityModelList, SalesEntityListInquiry, SystemModel, Institution, SalesRep, Chain, SalesEntityModel, AlliancePartner, Association, SalesEntityBoardingHierarchyNew, SalesEntityContact, Contract } from 'app/shared/models/EvoSalesPortalModel';
import { HttpErrorResponse } from '@angular/common/http';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormsValidationService } from '../../../../../../shared/services/formsValidation.service';
import { FormatService } from 'app/shared/services/format.service';
import { UserAccessService } from '../../../../../../shared/services/user-access.service';

@Component({
    selector: 'se-contract-editor-modal',
    styleUrls: ['se-contract-editor.scss'],
    templateUrl: 'se-contract-editor.html',
})
export class SalesEntityContractEditorComponent {
    bindingContext: BindingContext = new BindingContext();
    seForm: FormGroup;
    private subscription: ISubscription;
    private formValidatorSub: ISubscription;
    @Input() contract: Contract;
    @Input() salesEntityID: number;
    saving: boolean = false;
    ActionType: string = "Edit";
    public isDefault: boolean = false;

    private _formValid: boolean;
    public set FormValid(input: boolean) {
        this._formValid = input;
    }
    public get FormValid(): boolean {
        return this._formValid;
    }
    private _Contracts: Array<Contract> = new Array<Contract>();
    public get Contracts(): Array<Contract> {
        return this._Contracts;
    }
    public set Contracts(value: Array<Contract>) {
        this._Contracts = value;
    }
    private _SalesEntity: SalesEntityModel = new SalesEntityModel();
    public get SalesEntity(): SalesEntityModel {
        return this._SalesEntity;
    }

    constructor(public activeModal: NgbActiveModal,
        private seSvc: SalesEntityService,
        private formSvc: FormsValidationService,
        private formatService: FormatService,
        private accSvc: UserAccessService) {
        this.bindingContext.isBusy = false;
        this.CreateForm();
    }

    ngOnInit() {
        this.FetchDropDownData();
        //Inputs are loaded at this lifecycle event
        if (this.contract) {
            this.ActionType = "Edit";
            this.formSvc.BindDataToFormGroup(this.contract, this.seForm);
        } else {
            this.ActionType = "Add";
        }
    }

    ngOnDestroy() {
        if (this.subscription) { this.subscription.unsubscribe(); }
        if (this.formValidatorSub) { this.formValidatorSub.unsubscribe(); }
    }
    /**
     * Fetches dropdown data for the form.
     */
    public FetchDropDownData() {
        this.seSvc.getSalesEntity(this.salesEntityID).toPromise().then(resp => {
            this._SalesEntity = resp.SalesEntity;
            if (resp.SalesEntity.SalesEntityParentID) {
                //Fetch this sales entity (cached by now)
                this.seSvc.GetContractsBySalesEntity(resp.SalesEntity.SalesEntityParentID).toPromise().then(innerResp => {
                    //Fetch this sales entity ParentID contracts -> store in public var
                    this.Contracts = innerResp.Result;
                    if(innerResp.Result.length < 1) {
                        //Handle root entity case where there's no contracts.
                        this.seForm.get('ParentContractID').clearValidators();
                        this.seForm.get('ParentContractID').updateValueAndValidity();
                        (<FormControl>this.seForm.controls['ParentContractID']).setValue(null);
                    }
                });
            } else {
                //Parent Contracts do not exist (Root Entity)
                this.Contracts = undefined;
            }
        });
    }
    /**
    * Builds the formGroup for this input
    * @ Subscribes to form changes and binds the validity to the FormValid property
    */
    CreateForm() {
        //Create the form and it's validators
        this.seForm = new FormGroup({
            Name: new FormControl('', [Validators.required]),
            ParentContractID: new FormControl('', [Validators.required]),
            IsDefault: new FormControl(''),
            AutoBoard: new FormControl(''),
        });
        //Subscribe to form change events and validate dirty fields
        this.formValidatorSub = this.seForm.valueChanges.subscribe((data) => {
            //console.log(this.seForm.controls);
            this.FormValid = this.formSvc.formIsValid(this.seForm, true);
        });
    }

    onSubmit() {
        if (this.contract) {
            //We were provided a contract as input and are editing.
            //Save as existing contract
            this.saving = true;
            let tempEntity = new Contract();
            this.formSvc.BindFormGroupToData(this.seForm, tempEntity, true);
            tempEntity.SalesEntityID = this.contract.SalesEntityID;
            tempEntity.ContractID = this.contract.ContractID;
            console.log('SUBMISSION:', tempEntity);
            this.seSvc.UpdateContract(tempEntity).toPromise().then(resp => {
                //this.accSvc.Securable_RefreshSectionCache(undefined, undefined, this.contract.SalesEntityID,);
                this.accSvc.GetSecurableObjectByName("SALES-ENTITY|CONTRACTS|NAME", undefined, this.salesEntityID, undefined, true).then(resp => {
                    this.accSvc.Securable_RefreshSectionCache("SALES-ENTITY", undefined, this.salesEntityID, undefined, this.contract.ContractID, resp.ObjectSecurableID);
                    this.saving = false;
                    this.activeModal.close(true);
                });
            }).catch((resp: HttpErrorResponse) => {
                this.bindingContext.endGet();
                this.saving = false;
                alert('There was an error saving contract, please try again. Contact support if this problem persists.');
            });
        }
        else {
            //No provided contract, insert brand new
            this.saving = true;
            let tempEntity = new Contract();
            this.formSvc.BindFormGroupToData(this.seForm, tempEntity, true);
            tempEntity.SalesEntityID = this.salesEntityID;
            console.log('SUBMISSION:', tempEntity);
            this.seSvc.InsertContract(tempEntity).toPromise().then(resp => {
                this.saving = false;
                this.activeModal.close(true);
            }).catch((resp: HttpErrorResponse) => {
                this.bindingContext.endGet();
                this.saving = false;
                alert('There was an error saving contract, please try again. Contact support if this problem persists.');
            });
        }
    }
    public canSave() {
        if (this.contract) { //EDITING
            if (!this.FormValid || !this.seForm.dirty) {
                //Only validate dirty fields, 
                //but don't allow submission unless 1 or more is dirty
                return false;
            } else {
                //The form is valid, and dirty
                return true;
            }
        } else { //ADDING
            if (!this.seForm.dirty || !this.seForm.valid) {
                //The whole form dirty or not must be valid
                //And you can't submit anyway unless it's dirty
                return false;
            } else {
                //The form is dirty AND not valid
                return true;
            }
        }
    }
}
